import { Alert, Snackbar } from "@mui/material";

const SnackbarCopiedToClipboard = ({ open, setOpen }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={2000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
      <Alert
        onClose={() => setOpen(false)}
        severity="success"
        sx={{ width: "100%" }}>
        Copied to clipboard
      </Alert>
    </Snackbar>
  );
};
export default SnackbarCopiedToClipboard;
